
import { Vue, Options } from 'vue-class-component'

@Options({
  props: {
    direction: String
  }
})
export default class IconArrow extends Vue {
  direction!: string
}
